import React from "react";
import CustomPaper from "../CutomPaper";
import { Notification, TabIcons } from "../../../_app/types";
import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import IconComponent from "../IconComponent";
import { getDate, getTime } from "../../../utils/utils";
import AdronTypography from "../AdronTypography";
import DOMPurify from "dompurify";
import {decodeUnicodeString} from "../../../_utils/decodeUnicodeString";

interface Props {
  notification: Notification;
}

export default function NotificationCard({ notification }: Props) {
  const theme = useTheme();

  const TAB_ICONS: any = {
    INFO: {
      color: theme.palette.text.secondary,
      icon: (
        <IconComponent
          hasStroke
          customColor={theme.palette.text.primary}
          size={20}
          iconName={"InfoIcon"}
        />
      ),
    },
    ERROR: {
      color: "#F10000",
      icon: <IconComponent size={20} hasFill={true} iconName={"ErrorIcon"} />,
    },
    WARN: {
      color: "#A7E50A",
      icon: <IconComponent size={20} hasFill={true} iconName={"AlertIcon"} />,
    },
    // SUCCESS: {
    //     color: '#04D538',
    //     icon: <IconComponent size={20} iconName={'SuccessIcon'} />,
    // },
  };

  return (
    <CustomPaper>
      <Stack direction={"column"} gap={1}>
        <Stack sx={{ width: "100%" }} direction={"row"} justifyContent={"space-between"}>
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            {TAB_ICONS[notification.type].icon}
            <Typography
              sx={{ fontWeight: 700, color: TAB_ICONS[notification.type].color }}
              variant={"body2"}
            >
            </Typography>
          </Stack>
          <AdronTypography
            value={`${getDate(notification.eventTime)} ${getTime(notification.eventTime)}`}
            halfOpacity
          />
        </Stack>
        <Stack sx={{ width: "100%" }} direction={"row"} justifyContent={"space-between"}>
          <AdronTypography
            style={{ whiteSpace: "break-spaces", width: "100%" }}
            value={""}>
            <span
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  decodeUnicodeString(notification.message).replace(/\\n/g, "<br />")
                ),
              }}
            >
            </span>
          </AdronTypography>
          {notification.state === "NEW" && (
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor: theme.palette.primary.main,
              }}
            ></Box>
          )}
        </Stack>
      </Stack>
    </CustomPaper>
  );
}
